const { getElement, getElements } = window.BAO.Utils

class ProductAsVariantMobile extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['radio']
  }

  connectedCallback () {
    super.connectedCallback()

    this.desktopProductAsVariant = getElement('product-as-variant')

    if (!this.els.radio?.elements?.length) return

    this.updateElements(this.els.radio.elements[0])
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els.radio?.elements?.length) return

    this.els.radio.elements.forEach(radioEl => {
      this.listeners.add(radioEl, 'change', this.handleChange.bind(this))
    })
  }

  handleChange (event) {
    const currentRadioEl = event.target
    const labelEl = currentRadioEl.closest('label')
    const selectSizeEl = document.querySelector(
      '.prd-DetailForm_Button-selectSize',
    )
    const qtySelectEl = document.querySelector('.prd-Detail_Row-qty')
    const addToCartEl = document.querySelector('.prd-Detail_Buy-sizes')
    const quantityLimitEl = document.querySelector(
      '.prd-Detail_Message-mobileQuantityLimit',
    )
    const inStockQtyMessage = document.querySelector(
      '.prd-Detail_Message-inStock',
    )
    const soldOutStockQtyMessage = document.querySelector(
      '.prd-Detail_Message-soldOut',
    )

    if (!labelEl) return

    // Check the corresponding desktop radio button
    if (
      this.desktopProductAsVariant &&
      this.desktopProductAsVariant.els?.radio?.elements
    ) {
      const correspondingDesktopRadio = Array.from(
        this.desktopProductAsVariant.els.radio.elements,
      ).find(radioEl => radioEl.value === currentRadioEl.value)

      if (correspondingDesktopRadio && !correspondingDesktopRadio.checked) {
        correspondingDesktopRadio.checked = true

        correspondingDesktopRadio.dispatchEvent(
          new Event('change', { bubbles: true }),
        )
      }
    }

    this.els.radio.elements.forEach(radioEl => {
      radioEl.closest('label')?.setAttribute('aria-current', 'false')
    })

    labelEl.setAttribute('aria-current', 'true')

    selectSizeEl.setAttribute('aria-hidden', 'true')

    qtySelectEl.setAttribute('aria-hidden', 'false')

    addToCartEl.setAttribute('aria-hidden', 'false')

    quantityLimitEl.setAttribute('aria-hidden', 'false')

    inStockQtyMessage.setAttribute('aria-hidden', 'true')

    soldOutStockQtyMessage.setAttribute('aria-hidden', 'true')

    addToCartEl.classList.remove('prd-Detail_Buy-soldOut')

    if (
      labelEl.classList.contains(
        'prd-DetailClothingSizesMobile_Variant-unavailable',
      )
    ) {
      qtySelectEl.setAttribute('aria-hidden', 'true')

      inStockQtyMessage.setAttribute('aria-hidden', 'true')

      soldOutStockQtyMessage.setAttribute('aria-hidden', 'false')

      addToCartEl.classList.add('prd-Detail_Buy-soldOut')

      const mobileAddToBagBtn = document.querySelector(
        '.prd-DetailForm_Button-mobile',
      )

      mobileAddToBagBtn.removeAttribute('disabled')

      mobileAddToBagBtn.setAttribute('aria-hidden', 'false')
    }

    if (currentRadioEl.dataset.inventoryQuantity === 1) {
      inStockQtyMessage.setAttribute('aria-hidden', 'false')
    }

    if (currentRadioEl.dataset.inventoryQuantity > 1) {
      document.querySelector(
        '.prd-Detail_Qty .qty-Adjuster_Input',
      ).dataset.shouldBeDisabled = 'false'
      document.querySelector(
        '.prd-Detail_Qty .qty-Adjuster_Control-plus',
      ).dataset.shouldBeDisabled = 'false'
    } else {
      document.querySelector(
        '.prd-Detail_Qty .qty-Adjuster_Control-minus',
      ).dataset.shouldBeDisabled = 'true'
    }

    const selectMinValue = 1
    const selectMaxValue = currentRadioEl.dataset.inventoryQuantity

    for (let i = selectMinValue; i <= selectMaxValue; i++) {
      const opt = document.createElement('option')
      opt.value = i
      opt.innerHTML = i
    }

    this.updateElements(currentRadioEl)

    document.querySelector(
      '.prd-Detail_Quantity .qty-Adjuster_Input',
    ).dataset.shouldBeDisabled = 'false'
    document.querySelector(
      '.prd-Detail_Quantity .qty-Adjuster_Control-plus',
    ).dataset.shouldBeDisabled = 'false'
    document.querySelector('.prd-DetailForm_VariantErrorMsg')?.remove()
  }

  updateElements (currentRadioEl) {
    this.idInputEls?.forEach(
      idInputEl => (idInputEl.value = currentRadioEl.value),
    )

    this.quantityLimitEls?.forEach(quantityLimitEl => {
      quantityLimitEl.setAttribute(
        'available',
        currentRadioEl?.dataset?.available,
      )
      quantityLimitEl.setAttribute(
        'inventory-policy',
        currentRadioEl?.dataset?.inventoryPolicy,
      )
      quantityLimitEl.setAttribute(
        'inventory-quantity',
        currentRadioEl?.dataset?.inventoryQuantity,
      )
    })

    this.lowStockEls?.forEach(lowStockEl => {
      lowStockEl.setAttribute('available', currentRadioEl?.dataset?.available)
      lowStockEl.setAttribute(
        'inventory-policy',
        currentRadioEl?.dataset?.inventoryPolicy,
      )
      lowStockEl.setAttribute(
        'inventory-quantity',
        currentRadioEl?.dataset?.inventoryQuantity,
      )
    })

    this.quantityEls?.forEach(quantityEl => {
      if (currentRadioEl?.dataset?.inventoryQuantity > 0) {
        quantityEl.value = 1

        this.quantityLimitEls.forEach(quantityLimitEl =>
          quantityLimitEl.setAttribute('quantity', 1),
        )
      } else {
        quantityEl.value = 0
      }

      quantityEl.setAttribute('max', currentRadioEl?.dataset?.inventoryQuantity)
    })

    if (this.addToCartEl) {
      this.addToCartEl.setAttribute(
        'aria-hidden',
        currentRadioEl?.dataset?.available !== 'true',
      )
      this.addToCartEl.disabled = currentRadioEl?.dataset?.available !== 'true'
    }

    if (this.soldOutEl) {
      this.soldOutEl.setAttribute(
        'aria-hidden',
        currentRadioEl?.dataset?.available === 'true',
      )
      this.soldOutEl.disabled = currentRadioEl?.dataset?.available === 'true'
    }
  }

  get contextEl () {
    return getElement('[data-product-detail-blocks-mobile]')
  }

  get idInputEls () {
    return getElements('form[action*="/cart/add"] [name="id"]', {
      context: this.contextEl,
    })
  }

  get quantityLimitEls () {
    return getElements('product-quantity-limit', { context: this.contextEl })
  }

  get lowStockEls () {
    return getElements('product-low-stock', { context: this.contextEl })
  }

  get wishlistEls () {
    return getElements('[is="wishlist-heart"]', { context: this.contextEl })
  }

  get quantityEls () {
    return getElements('[name="quantity"]', { context: this.contextEl })
  }

  get addToCartEl () {
    return getElement('button[data-product-add-to-cart]', {
      context: this.contextEl,
    })
  }

  get soldOutEl () {
    return getElement('button[data-product-sold-out]', {
      context: this.contextEl,
    })
  }
}

if (!window.customElements.get('product-as-variant-mobile')) {
  window.customElements.define(
    'product-as-variant-mobile',
    ProductAsVariantMobile,
  )
}
